module.exports = __webpack_public_path__ + "static/media/wine_03.df5a1120.jpg";